import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { MatCardModule } from '@angular/material/card';

import { MatGridListModule, MatGridTile } from '@angular/material/grid-list';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,

    // MatCardModule,
    MatGridListModule,
    MatGridTile
    
  ]
})
export class HomeModule { }
export { HomeComponent };
